<script setup lang="ts">

import { useViewModel } from "./ActivateVehicleModel";

import SearchForm from "./Components/SearchForm.vue";
import ActivateVehicleForm from "./Components/ActivateVehicleForm.vue";
import VehicleActivatedConfirmation from "./Components/VehicleActivatedConfirmation.vue";
import AlreadyActivated from "./Components/AlreadyActivated.vue";

const model = useViewModel();

</script>

<template>

    <div class="flex flex-col w-full h-full items-start overflow-y-auto pt-6">

        <!-- HEADER AND LICENSE PLATE COMPONENT -->
        <div class="w-full bg-gradient-to-b from-gray-900 to-gray-850">
            <div class="text-center top-0 w-full px-4 lg:px-6"
                 :class="model.isReady == false ? 'pt-2' : 'pt-8'">

                <img src="@/assets/images/carbucks-dark-mode.png"
                     class="w-4/5 mx-auto transition-all duration-150"
                     :class="{ '-mt-20 !mb-0 opacity-0 scale-75': model.isReady == false }"
                />

                <IconButton v-if="model.isReady == false"
                    name="cross"
                    class="bg-white/10 z-10 -mt-1 -mb-3"
                    @click="() => model.reset()"
                />

                <h1 v-if="model.isReady"
                    class="text-xl mb-4 font-bold italic text-[#00addf]">
                    DEALER MODE
                </h1>

                <p v-if="model.isReady"
                    class="text-sm lg:text-base mb-4 opacity-70">
                    Enter the customer's rego to get started activating their vehicle
                </p>
            </div>
        </div>

        <div class="w-full flex flex-col gap-6 justify-start px-6
                    bg-gradient-to-b from-gray-850 to-gray-900">

            <!-- NO SEARCH HAS BEEN PERFORMED -->
            <div v-if="model.isReady">
                <SearchForm :model="model" />
            </div>

            <!-- SEARCH HAS BEEN PERFORMED AND WERE ACTIVATING OR CREATING A VEHICLE -->
            <div v-else-if="model.isMatched || model.isNotMatched">
                <ActivateVehicleForm v-model="model" />
            </div>

            <!-- VEHICLE HAS BEEN SUCCESSFULLY ACTIVATED -->
            <div v-else-if="model.isActivated">
                <VehicleActivatedConfirmation v-model="model" />
            </div>

            <!-- SEARCH HAS BEEN PERFORMED AND THE VEHICLE WAS ALREADY IN AN ACTIVE STATE -->
            <div v-else-if="model.isAlreadyActivated">
                <AlreadyActivated v-model="model" />
            </div>

        </div>

    </div>

</template>
